/**
 * Dati identificativi del titolare.
 *
 * AURA è un prodotto di OdyneAI: questo sito ne cura la promozione e la
 * vendita, quindi il titolare del sito e del servizio è OdyneAI stessa.
 * I dati qui sotto sono allineati a quelli pubblicati su odyneai.com.
 *
 * Obblighi di legge coperti da questo file:
 *  - art. 7 D.Lgs 70/2003 (servizi della società dell'informazione):
 *    denominazione, sede, estremi di contatto incl. email, REA, partita IVA;
 *  - artt. 13-14 GDPR: identità e contatti del titolare nell'informativa.
 *
 * Il titolare è un'impresa individuale: la partita IVA è unica e riferita alla
 * persona, non alla singola attività. È la stessa che compare su
 * triglide-emotion.com, l'altra attività dello stesso titolare.
 */

export const COMPANY = {
  // Nome commerciale del prodotto
  brand: "AURA",

  // Chi possiede il prodotto e gestisce il sito
  owner: "OdyneAI",
  ownerUrl: "https://odyneai.com",

  // Denominazione del titolare. Per un'impresa individuale il soggetto
  // giuridico è la persona fisica; "OdyneAI" è il nome commerciale con cui
  // si presenta questa attività.
  legalName: "Francesco Scigliuzzo",
  legalForm: "Impresa individuale",
  tradeName: "OdyneAI",

  address: {
    street: "Via Cavalieri di Rodi 15",
    zip: "73014",
    city: "Gallipoli",
    province: "LE",
    country: "Italia",
  },

  vat: "05476930754",
  taxCode: "SCGFNC87C30D883Y",
  rea: null, // non pubblicato; recuperabile dalla visura camerale
  shareCapital: null, // non applicabile alle imprese individuali

  // Foro competente per le controversie (sede del titolare)
  court: "Lecce",

  // Contatti
  email: "odyneai2026@gmail.com",
  pec: null,
  phone: "+39 351 311 0904",

  // Privacy
  privacyEmail: null, // se null usa `email`
  dpo: null, // non nominato: non ricorrono le condizioni dell'art. 37 GDPR

  // Versione e data delle informative: aggiornale a ogni modifica sostanziale
  legalVersion: "1.0",
  legalUpdatedAt: "30 luglio 2026",

  social: {
    instagram: "https://www.instagram.com/odyne_ai",
    linkedin: "https://www.linkedin.com/in/francesco-scigliuzzo-071660163",
    facebook: "https://www.facebook.com/share/18Lub2jaj4/",
  },
};

/**
 * Denominazione completa da mostrare al pubblico.
 * Per un'impresa individuale la convenzione è "[nome commerciale] di [persona]",
 * la stessa usata dall'altra attività dello stesso titolare.
 */
export const displayLegalName = () =>
  COMPANY.tradeName
    ? `${COMPANY.tradeName} di ${COMPANY.legalName}`
    : COMPANY.legalName;

/** Dati identificativi ancora mancanti per l'art. 7 D.Lgs 70/2003. */
export const missingLegalFields = () => {
  const missing = [];
  if (!COMPANY.vat) missing.push("partita IVA");
  if (!COMPANY.address) missing.push("sede legale");
  return missing;
};

/**
 * Sede legale su una riga, o null se non ancora nota.
 * I componenti devono trattare il null omettendo il dato, non stampandolo.
 */
export const formatAddress = () => {
  const a = COMPANY.address;
  if (!a) return null;
  const province = a.province ? ` (${a.province})` : "";
  return `${a.street}, ${a.zip} ${a.city}${province}, ${a.country}`;
};

/** Email a cui indirizzare le richieste privacy (artt. 15-22 GDPR). */
export const privacyContact = () => COMPANY.privacyEmail || COMPANY.email;

// In sviluppo ricorda che l'adempimento è ancora scoperto. In produzione tace:
// un avviso a schermo confonderebbe i visitatori senza aiutare nessuno.
if (process.env.NODE_ENV === "development") {
  const missing = missingLegalFields();
  if (missing.length) {
    console.warn(
      `[company.js] Dati identificativi mancanti: ${missing.join(", ")}. ` +
        "Obbligatori ex art. 7 D.Lgs 70/2003 — vanno compilati prima di considerare il sito conforme."
    );
  }
}
